import moment, { ISO_8601 } from 'moment';
import { from, map, switchMap, take } from 'rxjs';
import { HttpClient } from 'api/http-client';
import { pushes, UserChannel, EventType, ObjectType, Action } from 'api/pushes';
import { axios } from '../axios';
import { configuration, customerConfiguration, Channel } from './configuration';
export var SpaceTabType = /*#__PURE__*/ function(SpaceTabType) {
    SpaceTabType["RocketlaneDocument"] = "ROCKETLANE_DOCUMENT";
    return SpaceTabType;
}({});
export var ApprovalObjectType = /*#__PURE__*/ function(ApprovalObjectType) {
    ApprovalObjectType["Task"] = "Task";
    ApprovalObjectType["Document"] = "Document";
    return ApprovalObjectType;
}({});
export const NotificationGroup = {
    when: (task, document, project, conversation, statusUpdate, spaceTab, approval, timesheet, timeoff, financials, accounts, resourceRequest, invoice, expenseReport, otherwise)=>(group)=>{
            const typeless = group;
            if (typeless.task != null) {
                return task(typeless);
            }
            if (typeless.document != null) {
                return document(typeless);
            }
            if (typeless.project != null) {
                return project(typeless);
            }
            if (typeless.conversation != null) {
                return conversation(typeless);
            }
            if (typeless.statusUpdate != null) {
                return statusUpdate(typeless);
            }
            if (typeless.spaceTab != null) {
                return spaceTab(typeless);
            }
            if (typeless.approval != null) {
                return approval(typeless);
            }
            if (typeless.timesheet != null) {
                return timesheet(typeless);
            }
            if (typeless.timeOff != null) {
                return timeoff(typeless);
            }
            if (typeless.projects != null) {
                return financials(typeless);
            }
            if (typeless.company != null) {
                return accounts(typeless);
            }
            if (typeless.resourceRequest != null) {
                return resourceRequest(typeless);
            }
            if (typeless.invoice != null) {
                return invoice(typeless);
            }
            if (typeless.expenseReport != null) {
                return expenseReport(typeless);
            }
            return otherwise(typeless);
        }
};
export var NotificationStatus = /*#__PURE__*/ function(NotificationStatus) {
    NotificationStatus["New"] = "New";
    NotificationStatus["Cleared"] = "Cleared";
    return NotificationStatus;
}({});
export const Start = (start)=>[
        'start',
        start || (new Date().getTime() * 1000).toString()
    ];
export var Filter = /*#__PURE__*/ function(Filter) {
    Filter["All"] = "All";
    Filter["AssignedToMe"] = "AssignedToMe";
    Filter["AssignedToTeam"] = "AssignedToTeam";
    Filter["Mentions"] = "Mentions";
    return Filter;
}({});
// handles all the api calls for notifications and notification groups
export const notifications = {
    get: ({ uri }, status, filter, [, count], [, start])=>axios().pipe(take(1), switchMap(({ get })=>from(get(`/notifications?container=${uri}&status=${status}&count=${count}&start=${start}&filter=${filter}`))), map((response)=>response.data)),
    groups: (status, filter, [, count], [, start], [, size], exclusions = [], selectedCompany)=>// fetch the notifications based on the filter and status
        axios().pipe(take(1), switchMap(({ get })=>from(get('/notifications/groups' + `?status=${status}` + `&count=${count}` + `&start=${start}` + `&groupSize=${size}` + `&filter=${filter}` + `&exclusions=${exclusions.map((e)=>e.uri).join(',')}` + `${selectedCompany ? `&companyIds=${selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.companyId}` : ''}`))), map((response)=>response.data)),
    unclear: (key, filter)=>axios().pipe(take(1), switchMap(({ patch })=>from(patch(`/notifications?container=${key.uri}&filter=${filter}`, {
                status: "New"
            }))), map((response)=>response.data)),
    clear: (key, filter)=>axios().pipe(take(1), switchMap(({ patch })=>from(patch(`/notifications?container=${key.uri}&filter=${filter}`, {
                status: "Cleared"
            }))), map((response)=>response.data)),
    updates: (accountId, userId)=>// subscribe to the notifications channel for the user and account id
        // and map the messages to the notification type
        pushes(UserChannel(accountId, userId), EventType(Action.Create, ObjectType.Notification)).pipe(map(({ data })=>data)),
    // get the last seen at for the user and account id from the server
    // and return it as a stream of updates
    lastSeenAt: ()=>axios().pipe(take(1), switchMap(({ get })=>from(get('/notifications/last-seen-at'))), map((response)=>response.data.lastSeenAt), map((date)=>moment(date, ISO_8601))),
    companyLastSeenAt: (selectedCompany)=>axios().pipe(take(1), switchMap(({ get })=>from(get(`/notifications/company-last-seen-at?companyId=${selectedCompany.companyId}`))), map((response)=>response.data.lastSeenAt), map((date)=>moment(date, ISO_8601))),
    // update the last seen at date to the current time
    seen: ()=>axios().pipe(take(1), switchMap(({ post })=>from(post('/notifications/last-seen-at', {
                lastSeenAt: moment().toISOString()
            })))),
    configuration,
    customerConfiguration
};
// moving away from the above method of api calls, for clearing all notifications it has been written like this
class NotificationHttpClient extends HttpClient {
    async clearAllNotifications() {
        return this.put('/notifications/clear-all', {});
    }
}
export const NotificationAPI = new NotificationHttpClient();
export { Channel };
